import React, {Component} from 'react';

import withErrorHandler from '../hoc/withErrorHandler/withErrorHandler';
import axios from '../../axios-drops';
import StartingModal from '../../components/UI/Modal/StartingModal/StartingModal';
import EmailListModal from '../../components/UI/Modal/EmailListModal/EmailListModal';
import StartingModalMessage from '../../components/UI/Modal/StartingModalMessage/StartingModalMessage';
import ClickableDropInfoDisplay from '../ClickableDropInfoDisplay/ClickableDropInfoDisplay';
import TrdFallBack from '../../components/UI/TrdAdminFocus/TrdFallBack/TrdFallBack'
import Aux from '../hoc/Auxiliary';
import Spinner from '../../components/UI/Spinner/Spinner';

import classes from './DibsItLanding.css';




class dibsItLanding extends Component {

    state = {
        drops: [],
        loading: true,
        startingModal: false,
        showEmailModal: false
    }

    componentDidMount() {

        window.scrollTo(0, 0)

        let userIp = null
        const fetchedCurrentDrops = []
        const func = async () => {


            await axios.get('https://api64.ipify.org?format=jsonp?callback=?')
                .then(response => {
                    userIp = response.data
                })
            
            // console.log(userIp)

            await axios.get('./drops.json')
                .then(response => {
                    // const fetchedCurrentDrops = []
     
                    for (let key in response.data) {
                        
                        if (response.data[key].current && !response.data[key].dropClosed) {
                            
                            fetchedCurrentDrops.push({
                                ...response.data[key],
                                id: key
                            })
                        } 
                    }
            })

            

            const date = new Date();
            // 7 hourse later than pst time
            const dateFinal = date.toJSON().slice(0,10).replace(new RegExp("-", 'g'),"/" ).split("/").join("-")

            // console.log(dateFinal)

            let firstOfDay = false
            let saveUser = false

            await axios.get('./daily-reminder/' + dateFinal + '.json')
                .then(response => {
                    // console.log(response)
                    if (response.data) {    // current day exists in database
                        // check that data for userIp, will automatically not include null values since null ip wont be saved by firebase
                        // console.log(response.data)
                        loop: for (let key in response.data) {    // will go thru entire day of entries
                            
                            // console.log(response.data[key])
                           
                            if (userIp === response.data[key].ip){ // comparing current userIp with each data item ip in db
                                // if not equal then we will NOT SHOW STARTING MODAL 
                                // console.log('repeat')
                                saveUser = false
                                break loop
                            } else {
                                saveUser = true
                            }
                        }

                    }else {                 // new day being created by first user of day 
                        firstOfDay = true
                        console.log('check')
                    }
                })

                if (firstOfDay || saveUser) {

                    this.setState({
                        drops: fetchedCurrentDrops.reverse(),
                        loading: false,
                        startingModal: true
                    })

                    this.disableScroll()

                    const userCheck = {
                        ip: userIp
                    }
    
                    await axios.post('./daily-reminder/' + dateFinal + '.json', userCheck)
                    .then(result => {
                        
                    })
                } else {
                    this.setState({
                        drops: fetchedCurrentDrops.reverse(),
                        loading: false,
                        startingModal: false
                    })
                }
                

     
        }

        func()

        
    }

    

    openTrdHandler = (id) => {
        this.props.history.push({pathname: '/trd/' + id})
    }

    closeModalHelper = () => {
        this.enableScroll()
        this.setState({ startingModal: false})
    }

    closeEmailModalHelper = () => {
        this.setState({ startingModal: false,
                        showEmailModal: false})
    }

    emailListClickedHelper = () => {


        this.setState({ startingModal: false,
                        showEmailModal: true})
    }

    disableScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

        window.onscroll = () => {
            window.scrollTo(scrollLeft, scrollTop)
        }
    }

    enableScroll = () => {
        window.onscroll = () => {}
    }

    render() {

        

        let currentDropsGroup = <div className={classes.Spinner} ><Spinner /></div>


        if (this.state.drops.length > 0 && !this.state.loading ) {
            currentDropsGroup = (
            <Aux>
                <div className={classes.TitleSection}>
                    <h3 className={classes.Title}>Click on a drop to register!</h3>
                </div>
                <hr/>
                <div className={classes.DropMenu}>
                    {this.state.drops.map((drop, index) => (
            
                        <ClickableDropInfoDisplay
                            key={drop.id}
                            clicked={() => this.openTrdHandler(drop.id)}
                            image={drop.image}
                            name={drop.name}
                            variant={drop.variant}
                            edition={drop.edition} 
                            cost={drop.cost}
                            numberAvailable={drop.availability}
                            originallyAvailable={drop.originallyAvailable}
                            type={drop.type}
                            id={drop.id}
                            />
                    ))}
                </div>
            </Aux>)

        } else if (!this.state.loading) {
            currentDropsGroup = <TrdFallBack />
        }

        return (
            <Aux> 
                <StartingModal show={this.state.startingModal} modalClosed={this.closeModalHelper}>
                    <StartingModalMessage clicked={this.emailListClickedHelper}/>
                </StartingModal>
                <EmailListModal show={this.state.showEmailModal} modalClosed={this.closeEmailModalHelper} />

                <div className={classes.DibsItLanding}>
                    {currentDropsGroup}
                </div> 
            </Aux>
            
        ) 
    }
}

export default withErrorHandler(dibsItLanding, axios)


// WEBPACK FOOTER //
// ./src/containers/DibsItLanding/DibsItLanding.js